<div class="container">
  <div class="my-request">

    <!-- Job Card Sidebar (Find My Car Sidebar) -->
    <div class="overlay" [class.visible]="isVisible" (click)="closeAll()" ></div>
    <!-- <div class="scroll-container" > -->
    <div class="job-card-sidebar sidebar" *ngIf="isVisible" (click)="$event.stopPropagation()">
      <!-- <div class="sidebar-header" (click)="onCreateJobCardClick()"> -->
      <div class="sidebar-header1" >
        <div class="close-btn-side-slider1">
          <mat-icon (click)="closeSidebar(false)" class="kybrdbckspc">keyboard_backspace</mat-icon>
          <h2>Create Job Card</h2>
        </div>
        <!-- <button class="close-sidebar" (click)="closeSidebar(false)">×</button> -->
        <mat-icon class="close-sidebar" (click)="closeSidebar(false)">close</mat-icon>
      </div>
      <hr />
      <form class="container" [formGroup]="vehicleForm1" (ngSubmit)="onRegDecodeSubmit()">
        <!-- <div *ngIf="!bookingId">
          <label for="name" style="font-weight: bolder;">Enter your name <span class="required">*</span></label>
          <div class="input-group">
            
          <span class="small-img"><mat-icon class="input-icon" alt="">person_outline</mat-icon> NM</span>
            <input id="name" type="text" placeholder="Enter your name" formControlName="name"> -->
           <!-- <TextField id="outlined-basic" label="Outlined" variant="outlined" /> -->
          <!-- </div>
          <div *ngIf="(vehicleForm1.get('name').invalid && vehicleForm1.get('name').touched || formSubmitted) || (vehicleForm1.get('name').invalid && formSubmitted)" style="color: red;">
            Enter Valid Name
          </div>
        </div> -->
    
        <!-- <div *ngIf="!bookingId">
          <label for="phoneNumber" style="font-weight: bolder;">Enter your Mobile Number <span class="required">*</span></label>
          <div class="input-group">
            
          <span class="small-img"><mat-icon class="input-icon" alt=""> phone</mat-icon>+91</span>
            <input id="phoneNumber" type="text" placeholder="Enter your Mobile Number" formControlName="phoneNumber" pattern="[0-9]*" maxlength="10">
          </div>
          <div *ngIf="(vehicleForm1.get('phoneNumber').invalid && vehicleForm1.get('phoneNumber').touched || formSubmitted) || (vehicleForm1.get('phoneNumber').invalid && formSubmitted)" style="color: red;">
            Enter Valid Mobile Number
          </div>
        </div> -->
    
        <!-- <label for="odometer" style="font-weight: bolder;">Enter Odometer Reading <span class="required">*</span></label>
        <div class="input-group">
          <span class="small-img"><img src="assets/images/my-job-card-images/carkm.png" class="input-icon" alt="Car KM"> KM</span>
          <input id="odometer" type="text" placeholder="10000" formControlName="odometer">
        </div>

        <div *ngIf="(vehicleForm1.get('odometer').invalid && vehicleForm1.get('odometer').touched || formSubmitted) || (vehicleForm1.get('odometer').invalid && formSubmitted)" style="color: red;">
          Enter Valid Odometer Reading
        </div> -->
    
        <label for="regNo" style="font-weight: bolder; ">We recommend to enter car number <span class="required">*</span></label>
        <div class="input-group">
          <span class="small-img"><img src="assets/images/my-job-card-images/circle.png" class="input-icon" alt="Car Number"> IND</span>
          <input id="regNo" placeholder="KA 04 JA54**" maxlength="13" style="font-weight: 800;" formControlName="regNo">
        </div>
        <div *ngIf="(vehicleForm1.get('regNo').invalid && vehicleForm1.get('regNo').touched || formSubmitted) || (vehicleForm1.get('regNo').invalid && formSubmitted)" style="color: red;">
        <!-- <div *ngIf="formSubmitted && vehicleForm1.invalid" style="color: red; margin-top: 10px;"> -->
          Please fill Correct Registration Number.
        </div>
    
        <input type="hidden" formControlName="rowKey">
        <input type="hidden" formControlName="variantKey">
    
        <ul class="info-list">
          <li><img src="assets/images/my-job-card-images/ic_check.png" class="circle-img" alt="Check Circle">
            <span class="get">Get accurate details</span>
          </li>
          <li><img src="assets/images/my-job-card-images/ic_check.png" class="circle-img" alt="Check Circle">
            <span class="get">Get 2X faster results</span>
          </li>
        </ul>
    
        <button type="submit" mat-raised-button color="accent" class="submit-btn" aria-label="VEHICLE"   [ngStyle]="{'background-color': vehicleForm1.invalid ? '#888' : '#144579'}"
        [disabled]="vehicleForm1.invalid">
          FIND MY CAR
        </button>
        <!-- <button mat-raised-button color="accent" class="submit-button" aria-label="VEHICLE" [disabled]="vehicleForm1.invalid">
          FIND MY CAR
      </button> -->
        <p class="manual-selection" (click)="redirectToManualSelection()" >
          Or select car manually</p>
      </form>
    </div>
    
    <!-- Confirmation Sidebar (After Find My Car) -->
    <div class="overlay" [class.visible]="isConfirmationSidebarOpen" (click)= "closeAll()"></div>
    <div class="confirmation-sidebar" *ngIf="isConfirmationSidebarOpen && jobCardDetails" (click)="$event.stopPropagation()">
        <div class="confirmation-content">
          <!-- <div class="header-container">
            <mat-icon class="back-arrow" (click)="toggleConfirmationSidebar()">arrow_back</mat-icon>
            <mat-icon style="color: #144579;">directions_car</mat-icon>
          </div> -->
          <div class="logo-container">
            <div class="logoandtext">
              <img class="logoimg"src="../../../../assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo">
              <p style="font-size: 12px;"><strong>AUTOVERSE</strong></p>
            </div>
            <!-- <img class="shareimg"src="../../../../assets/images/share.png" alt="Share" (click)="shareDetails()" > -->
          </div>
          <h2 class="registration-number">{{jobCard.registrationNumber}}</h2>
          <div class="confirmdiv">Confirm your car details</div>
          <div class="details-item">
            <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check" class="circle-img">
            <div class="label">Make:</div>
            <div class="value">{{ jobCard.make }}</div>
          </div>
          <div class="details-item">
            <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
            <div class="label">Model:</div>
            <div class="value">{{ jobCard.model }}</div>
          </div>
          <div class="details-item">
            <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
            <div class="label">Variant:</div>
            <div class="value">{{ jobCard.variant }}</div>
          </div>
          <div class="details-item">
            <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
            <div class="label">MFG Year:</div>
            <div class="value">{{ jobCard.mfgYear }}</div>
          </div>
          <div class="details-item">
            <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
            <div class="label">Fuel:</div>
            <div class="value">{{ jobCard.fuelType }}</div>
          </div>
          <div *ngIf="jobCard.vin !== undefined && jobCard.vin !== '' && jobCard.vin !== undefined"  class="details-item">
            <img src="assets/images/my-job-card-images/ic_check.png" alt="ic_check">
            <div class="label">VIN:</div>
            <div class="value">{{ jobCard.vin }}</div>
          </div>
          <button class="confirm-btn" (click)="confirmDetails()">Confirm</button>
          <button class="change-car-btn" (click)="toggleConfirmationSidebar()">Change Car</button>
        </div>
    </div>

    <!-- Job Card Created Pop-up Modal -->
    <div class="overlay" [class.visible]="isJobCardCreatedPopupVisible" (click)= "closeJobCardPopup()"></div>
    <!-- <div class="confirmation-sidebar" *ngIf="isConfirmationSidebarOpen && jobCardDetails" (click)="$event.stopPropagation()"> -->
    <div *ngIf="isJobCardCreatedPopupVisible" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <img src="{{successIcon}}" alt="Success Icon" class="success-icon">
          <h2>Job Card Created</h2>
          <button class="close-modal" (click)="closeJobCardPopup()">
            <mat-icon>close</mat-icon>
        </button>
        </div>
        <div class="modal-body">
          <p>Job Card ID: <span class="job-card-id">{{jobCardId}}</span></p>
          <p><span class="createdAt1">{{date}}</span></p>
          <p>Let us deliver an awesome experience!</p>
        </div>
        <div class="modal-footer">
          <button class="share-job-card-btn" (click)="navigateToDetails(jobCardId,bookingId)">View Job Card</button>
        </div>
      </div>
    </div>
  <!-- </div> -->
</div>

  <div #scrollContainer class="side-slider" *ngIf="customerDetailsANDcarDetails && !jobCardDetails">
    <div class="side-slider-content">
      <div class="backspare-and-history-btn">
        <div class="close-btn-side-slider" (click)="goBack()" style="display: flex; align-items: center;">
            <mat-icon>keyboard_backspace</mat-icon>
            <h2 *ngIf="!exteriorSection && !imageSection">Create Job Card</h2>
            <div class="exterior-top"*ngIf="exteriorSection">Exterior Checks</div>
            <div class="exterior-top"*ngIf="imageSection"> Add Images</div>
        </div>
        <!-- <div class="changebtn" *ngIf="showServiceHistory"> -->
          <div class="changebtn" *ngIf="isExistingCustomer === true && showServiceHistory">
          <button class="history-btn" (click)="openServiceHistory()">Service History</button>
        </div>
      </div>
      
      <div class="car-header1">
        <div class="car-header" [ngClass]="{ 'class-header-with-no-customer': !isExistingCustomer && isExistingCustomer !== true }"        >
          <!-- <div class="jobcard-new-tag">{{jobCard.ExistingCustomer}}</div> -->
          <div class="jobcard-new-tag" *ngIf="isExistingCustomer == true">
            Repeat Customer
          </div>
          <div class="jobcard-tag" *ngIf="isExistingCustomer == false">
            New Customer
          </div>
          <div class="infoandchange">
            <div class="car-info">
              <!-- <img class="car-image" src="car-image-url" alt="Car" /> -->
              <div class="car-image">
                <img [src]="getMakeImageUrl(jobCard.make)" alt="Car Make Image" class="model-icon">
              </div>

              <div>
                <div>{{ jobCard.model }}, {{ jobCard.fuelType }}</div>
                <div style="display: flex;">
                  <div class="variantyearrn">{{ jobCard.variant }}</div>
                  <div class="variantyearrn">[{{jobCard.mfgYear}}]</div>
                </div>
                <div class="variantyearrn">{{ jobCard.registrationNumber}}</div>
                <div *ngIf="jobCard.vin !== undefined" class="variantyearrn">{{ jobCard.vin}}</div>
              </div>
            </div>
            <div class="changebtn1">
              <button class="change-btn"(click)="onChangeCarClick()">Change</button>
            </div>
          </div>
        </div>
      </div>
      <!-- <hr /> -->
      <div *ngIf="carDetailsandcustomerDetails">
        <form [formGroup]="carDetailsForm">
        <div class="car-details">
          <div style="display: flex;">
            <h3>Car Details </h3>
            <img src="../../../../assets/images/icons8-car-100.png" class="car-details-imgage">
          </div>
          <form>
            
            <div *ngIf="isManualSelection">
              <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true">
                <mat-label>
                  Reg Number<span class="required-asterisk">*</span>
                </mat-label>
                <input
                  matInput
                  placeholder="Enter Registration Number"
                  [(ngModel)]="car.regNumber"
                  (ngModelChange)="car.regNumber = car.regNumber.toUpperCase()"
                  name="regNumber"
                  required
                  id="regNumber"
                  class="custom-placeholder" maxlength="10"
                />
                <mat-error *ngIf="!car.regNumber">
                  Registration Number is required.
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true">
                <mat-label>VIN</mat-label>
                <input
                  matInput
                  placeholder="Enter VIN"
                  [(ngModel)]="car.vin"
                  name="vin"
                  id="vin"
                  class="custom-placeholder"
                />
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true">
              <mat-label>
                Engine Number
              </mat-label>
              <input
                matInput [(ngModel)]="car.engineNumber" name="engineNumber"
                id="engineNumber"
                placeholder="Enter Engine Number"
                [(ngModel)]="car.engineNumber" />


                <!-- <input
                matInput
                placeholder="Enter Odometer Reading"
                [(ngModel)]="car.odometerReading"
                name="odometerReading"
                required
                id="odometerReading"
                class="custom-placeholder"
              /> -->
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true">
              <mat-label>
                Odometer Reading<span class="required-asterisk">*</span>
              </mat-label>
              <input
                matInput
                placeholder="Enter Odometer Reading"
                [(ngModel)]="car.odometerReading"
                name="odometerReading"
                required
                id="odometerReading"
                class="custom-placeholder"
                type="tel"
                inputmode="numeric"
              />
              <mat-error *ngIf="rf.odometerReading?.hasError('required')">
                Enter Odometer Reading.
              </mat-error>
              <mat-error *ngIf="rf.odometerReading?.hasError('pattern')">
                Odometer reading must be numeric.
              </mat-error>
            </mat-form-field>            
            <div *ngIf="errorMessage4" class="error-message-new">
                      {{ errorMessage4 }}
            </div>
            <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true" >
              <mat-label>Last Service Date</mat-label>
              <!-- <input matInput [matDatepicker]="picker"  /> -->
              <input
              matInput
              placeholder="select last service date Reading"
              [(ngModel)]="car.lastServiceDate"
              name="lastServiceDate"
              id="lastServiceDate"
              class="custom-placeholder"
              [matDatepicker]="picker"
            />
              <!-- <input
                matInput
                placeholder="Enter Odometer Reading"
                [(ngModel)]="car.odometerReading"
                name="odometerReading"
                required
                id="odometerReading"
                class="custom-placeholder"
              /> -->
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <div class="service-form-group" id="serviceTypeInput" >
              <div class="dropdown-container" (click)="toggleDropdown()">
                <div style="display: flex; width: 100%;">
                  <div class="input-container">
                    <label for="type-select">Service Type<span class="required">*</span></label>
                  </div>
                  <mat-icon style="top: 1px; position: relative;" >keyboard_arrow_down</mat-icon>
                </div>
              </div>
              <!-- <div  class="error-message-service" style="font-weight: 900;  font-size: 12px; margin-left: 6px; margin-top: 10px; margin-bottom: 5px; color: red;">
                Please Select Service Type.
              </div> -->
              <div class="dropdoencompleteitems" *ngIf="isDropdownOpen">
                <div class="dropdown-options" id="dropdownOptions">
                  <div *ngFor="let service of serviceList" class="dropdown-item">
                    <label> 
                      <div class="dropdownitemnames">{{ service }}</div>
                      <input
                        type="checkbox"
                        [checked]="car.selectedServices.includes(service)"
                        (change)="selectService(service, $event)"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- Chips display for selected services -->
              <div *ngIf="car.selectedServices.length > 0">
                <div class="chips-container">
                  <div class="chip" *ngFor="let service of car.selectedServices">
                    {{ service }}
                    <span class="close-icon" (click)="removeService(service)">×</span>
                  </div>
                </div>
              </div>
            </div>
            
          </form>
        </div>
        <div *ngIf="errorMessage" class="error-message-new1">
          {{ errorMessage }}
        </div>
        <!-- -------------------------CARDETAILS FIELD--------------- -->
        <div class="car-detailsnew">
          <div class="customerdetailsandicon">
            <div style="display: flex;">
              <h3>Customer Details</h3>
              <img src="../../../../assets/../assets/images/icons8-customer-100.png" class="customer-details-imgage">
            </div>
          </div>
          <form>
            <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true">
              <mat-label>
                Name<span class="required-asterisk">*</span>
              </mat-label>
              <input id="customerName"
                matInput
                placeholder="Enter Name"
                [(ngModel)]="customer.name"
                name="customerName"
                required maxlength="20"
              />
              <mat-error *ngIf="rf.customerName?.hasError('required')">
                Enter the Customer's Name.
              </mat-error>
              <mat-error *ngIf="rf.customerName?.hasError('pattern')">
                Name should only contain letters.
              </mat-error>
            </mat-form-field>
            <div *ngIf="errorMessage3" class="error-message-new">
              {{ errorMessage3 }}
            </div>
            <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true">
              <mat-label>
                Mobile<span class="required-asterisk">*</span>
              </mat-label>
              <input id="customerMobileInput"
                matInput
                placeholder="Enter Mobile Number"
                [(ngModel)]="customer.mobile"    name="customerMobile"   required maxlength="10"  pattern="[0-9]*" type="tel"
                inputmode="numeric"
                
              />
            </mat-form-field>     
               <div *ngIf="errorMessage1" class="error-message-new">
                {{ errorMessage1 }}
              </div>
            <div *ngIf="errorMessage2" class="error-message-new">
                {{ errorMessage2 }}
              </div>
            <mat-form-field appearance="outline" class="form-field" id="ratecardTypeInput">
  <mat-label>Email</mat-label>
  <input
    matInput
    placeholder="Enter Email Address"
    type="email"
    [(ngModel)]="customer.email"
    name="customerEmail"
  />
</mat-form-field>

        <mat-form-field appearance="outline" class="form-field" [hideRequiredMarker]="true" (click)="fetchRateCardTypes()">
          <mat-label>Ratecard Type<span class="required-asterisk">*</span></mat-label>
          <mat-select [(value)]="selectedRatecardType"
                    name="ratecardType" required >
            <mat-option *ngFor="let type of ratecardTypes" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
            <div *ngIf="errorMessage5" class="error-message-new">
                {{ errorMessage5 }}
            </div>


          </form>
        </div>
        <div  #nextButton class="classnext">
          <button class="create-order-btn" (click)="saveDetails()">NEXT</button>
        </div>

        <!-- <div class="classnext">
          <button
            type="submit"
            mat-raised-button
            color="accent"
            class="create-order-btn"
            aria-label="NEXT"
            [ngStyle]="{
              'background-color': carDetailsForm.invalid ? '#888' : '#144579',
              'color': carDetailsForm.invalid ? '#fff' : '#fff'
            }"
            [disabled]="carDetailsForm.invalid"
            (click)="saveDetails()"
          >
            NEXT
          </button>
        </div> -->
        
      </form>
      </div>
      
      <!-- --------------------FUEL TYPE SECTION---------------- -->
      <div #scrollContainer *ngIf="fuelAccessoriesContainer && !carDetailsandcustomerDetails" class="fuel-accessories-container">
        <!-- Fuel Level Section -->
        <div class="fuel-level-section">
          <!-- <label for="fuel-level">Fuel Level</label> -->
           <div class="fuel-and-camera-icon">
            <p>Fuel Level: {{ fuelAndAccessories.fuelLevel }}%</p>
            <div class="fuel-image-upload" *ngIf="!fuelMeterImage">
              <button class="add-image-btn" (click)="fuelImageInput.click()">
                <mat-icon>add_a_photo</mat-icon> 
                <div class="Add-image-photo">ADD IMAGES</div>
              </button>
              <input
                #fuelImageInput
                type="file"
                accept="image/*"
                hidden
                (change)="onFuelImageSelected($event)"
              />
            </div>
          </div>


           <!-- Show preview if fuel image is selected -->
           <div *ngIf="fuelMeterImage" class="fuel-image-preview">
            <div class="image-container">
              <!-- {{fuelMeterImagePreview}} -->
              <div *ngFor="let image of fuelMeterImagePreview" >
                
                <img [src]="image" alt="Fuel Meter Image" (click)="openViewer(i)" style="cursor: pointer;">
                <div class="fuel-mete-image-tag">Fuel Level</div>

                <!-- Display tag or default to 'Fuel Level' -->
              </div>
              <span class="delete-icon-fuel" (click)="removeFuelImage()">✖</span>
            </div>
           
          </div>

          <div >
                      <!-- Image Viewer Popup -->
        <div class="image-viewer" *ngIf="isViewerOpen">
          <div class="image-container-view">
            <button class="close-btn-quote" (click)="closeViewer()">✖</button>
            <!-- <button class="prev-btn-quote" (click)="prevImage1()">&#10094;</button> -->
            <img [src]="selectedImage" class="full-image">
            <!-- <button class="next-btn-quote" (click)="nextImage1()">&#10095;</button> -->
          </div>
        </div>
            <span>E</span>
            <!-- Bind the fuel level input to fuelAndAccessories.fuelLevel and show percentage -->
            <input
              type="range"
              min="0"
              max="100"
              [(ngModel)]="fuelAndAccessories.fuelLevel"
              (ngModelChange)="updateFuelLevel($event)"
            />
            <span>F</span>
          </div>
        </div>
      
        <!-- Accessories Section -->
        <div class="accessories-section">
          <div style="display: flex;justify-content: space-between; padding: 0px 20px 0px 0px;">
          <h3>Accessories</h3>
          <div class="accessories-image-upload" >
            <button class="add-image-btn" (click)="accessoriesImageInput.click()">
              <mat-icon>add_a_photo</mat-icon> 
              <div class="Add-image-photo">ADD IMAGES</div>
            </button>
            <input  #accessoriesImageInput   type="file"   accept="image/*"  multiple  hidden (change)="onAccessoriesImagesSelected($event)"  />         
          </div>           
        </div>
        <!-- Show previews if accessories images are selected -->
        <div *ngIf="accessoriesImagesPreview.length > 0" class="accessories-image-preview">
          <div class="image-container" *ngFor="let accessoryimage of accessoriesImagesPreview; let i = index" (click)="openViewerAccessories(i)">
            <img  [src]="accessoryimage" alt="Accessories Image" style="margin-top: 10px; width: 100px; height:100px; border-radius: 8px; border: 1px solid #ccc; margin-left: 20px;" />
            <span class="delete-icon-accessories" (click)="removeAccessoryImage(i)">✖</span>
            <div class="accessory-image-tag">
              Accessory {{ i + 1 }}
            </div>
          </div>
          <!-- <img *ngFor="let accessoryimage of accessoriesImagesPreview" 
                [src]="accessoryimage" 
                alt="Accessories Image" 
                style="margin-top: 10px; width: 100px; height:100px; border-radius: 8px; border: 1px solid #ccc; margin-left: 20px;" /> -->
        </div>
          <ul>
            <li *ngFor="let accessory of accessories">
              <img [src]="accessory.imageUrl" [alt]="accessory.description" (click)="openViewerAccessories()">
              <label>
                {{ accessory.description }}
                <!-- Update the checked state based on fuelAndAccessories.checkedItems -->
                <input
                  type="checkbox"
                  [checked]="fuelAndAccessories.checkedItems.includes(accessory.description)"
                  (change)="selectAccessory(accessory.description, $event)"
                />
              </label>
            </li>
          </ul>
          <div #nextButton class="classnext">
            <button class="create-order-btn" (click)="goToIssuesSection()">NEXT</button>
          </div>

          <!-- Image Viewer Popup -->
            <div class="image-viewer" *ngIf="isAccessoriesViewerOpen">
              <div class="image-container-view-accessories">
                <button class="close-btn-quote" (click)="closeViewerAccessories()">✖</button>
                <button class="prev-btn-quote" (click)="prevImage1()">&#10094;</button>
                <img [src]="selectedImage" class="full-image-accessories">
                <button class="next-btn-quote" (click)="nextImage1()">&#10095;</button>
              </div>
            </div>
        </div>
      </div>
      
      <!-- --------------------FUEL TYPE SECTION END---------------- -->
      <!-- --------------------ISSUES SECTION---------------- -->
      <div #scrollContainer *ngIf="issuesSection && !fuelAccessoriesContainer" class="issues-section">
        <div class="issues-header1">
          <div class="issues-header">
            <div class="warning-maticon-new">
              <mat-icon class="warning-maticon">warning</mat-icon>
              <h3>Do you have more issues?</h3>
            </div>
            <p style="color: #888;">
              Please mention any symptoms (issues) you have noticed in your car. This
              will help our technician to diagnose better.
            </p>
          </div>
        </div>

        <div class="SearchBarContainer" (click)="toggleSearch()">
          <div class="SearchBarButton">

            <div class="SearchBarIcon">
              <i class="material-icons-search">search</i>
            </div>

            <input type="text" class="SearchBarInput" placeholder="Search Your Issues"  
              [(ngModel)]="searchText" 
              (input)="filterIssues()" 
              (keydown.enter)="addTag()"  /> 

            <div class="remove-search-suggestion" *ngIf="filteredIssues"(click)="clearSearch()" >
              <mat-icon *ngIf="searchText?.length>0">close</mat-icon>
            </div> 
                        
          </div>
        </div>
        <div *ngIf="selectedIssues.length > 0" >
          <div  class="issue-chips-container">
            <div class="chip" *ngFor="let issue of selectedIssues">
              {{ issue }}
              <span class="close-icon" (click)="removeIssue(issue)">×</span>
            </div>
          </div>
        </div>
        <div class="issues-section1" *ngIf="searchText?.length > 0 && filteredIssues.length > 0">
          <ul>
            <li *ngFor="let issue of filteredIssues" [ngClass]="{ 'highlighted-item': issue.isHighlighted }">
              <label [innerHTML]="highlightMatch(issue, searchText)"></label>
              <input
                type="checkbox"
                [checked]="issue.selected"
                (change)="toggleIssue(issue, $event)"
              />
              {{ issue.description }}
            </li>
          </ul>
        </div>
         
        <!-- </div> -->
        <div #nextButton class="classnext">
          <button class="create-order-btn" (click)="saveIssue()" >NEXT</button>
        </div>
      </div>
      <!-- --------------------ISSUES SECTION END---------------- -->

       <!-- --------------------EXTERIOR SECTION---------------- -->
        
       <div #scrollContainer *ngIf="exteriorSection && !issuesSection" class="exterior-section">
        <div class="exterior-tabs">
          <button 
            class="tab" 
            [class.active]="selectedTab === 'Front'" 
            (click)="selectTab('Front')">Front</button>
            <button 
            class="tab" 
            [class.active]="selectedTab === 'Rear'" 
            (click)="selectTab('Rear')">Rear</button>
            <button 
            class="tab" 
            [class.active]="selectedTab === 'Right'" 
            (click)="selectTab('Right')">Right</button>
            <button 
            class="tab" 
            [class.active]="selectedTab === 'Left'" 
            (click)="selectTab('Left')">Left</button>
          <button 
            class="tab" 
            [class.active]="selectedTab === 'Top'" 
            (click)="selectTab('Top')">Top</button> 
        </div>
      
        <div class="exterior-content">
          <div class="penciliconandtext">
            <p>Mark <span class="red-x">X</span> where damaged</p>
            <button class="pencil-icon" (click)="enableDrawing()" [ngClass]="{'active': isDrawing}">
              <!-- <mat-icon [ngStyle]="{'color': isDrawing ? selectedColor : 'black'}">edit</mat-icon> -->
            </button>
            
            <!-- <button class="undo-icon" (click)="undoDrawing()">
              <mat-icon class="undoicon">undo</mat-icon>
            </button> -->
          </div>
      
          <div #carImageContainer class="car-image-container">
            <div class="image-canvas-container" (mousedown)="activateDrawing($event)">
              <img *ngIf="selectedTab === 'Front'" src="../../../../assets/images/Car_Front _001.png" alt="Front View" (load)="onImageLoad()">
              <img *ngIf="selectedTab === 'Top'" src="../../../../assets/images/Car_Top_005.png" alt="Top View">
              <img *ngIf="selectedTab === 'Rear'" src="../../../../assets/images/Car_Rear_003.png" alt="Rear View">
              <img *ngIf="selectedTab === 'Right'" src="../../../../assets/images/Car_Right_004.png" alt="Right View">
              <img *ngIf="selectedTab === 'Left'" src="../../../../assets/images/Car_Left_002.png" alt="Left View">
      
              <canvas #drawingCanvas class="drawing-canvas" (touchstart)="startDrawing($event)" 
              (touchmove)="draw($event)" 
              (touchend)="stopDrawing()" 
              (touchcancel)="stopDrawing()"
              (mousedown)="startDrawing($event)"
              (mousemove)="draw($event)"
              (mouseup)="stopDrawing()"
              (mouseleave)="stopDrawing()"></canvas>
            </div>
          </div>
      
          <!-- <button class="save-icon" (click)="saveMarkedImage()">Save</button> -->
        </div>
        <!-- <div *ngIf="isImageSaved" class="saved-image-container">
          <div *ngFor="let tab of getDamagedTabs()" class="saved-image-item">
            <p>{{ tab }}:</p>
            <img [src]="damagedImagesData[tab]" alt="{{ tab }} Marked Image">
          </div>
        </div>   -->
      
        <div #nextButton class="classnext">
          <button #nextButton class="create-order-btn" (click)="goToNextTab()">NEXT</button>
        </div>
      </div>
    
      <!-- --------------------EXTERIOR SECTION END---------------- -->

      <!-- --------------------IMAGE SECTION ---------------- -->
      <div #scrollContainer *ngIf="imageSection && !exteriorSection" class="image-section">
        <div class="image-grid">
          <div>
            <div class="image-box" (click)="triggerFileInput('front')">
              <ng-container *ngIf="frontImage; else defaultIcon">
                <img [src]="frontImage" alt="Front" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <span class="image-gridtext">Front</span>
          </div>
          <div>
            <div class="image-box" (click)="triggerFileInput('engine')">
              <ng-container *ngIf="engineImage; else defaultIcon">
                <img [src]="engineImage" alt="Engine" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <span class="image-gridtext">Engine</span>
          </div>
          <div>
            <div class="image-box" (click)="triggerFileInput('battery')">
              <ng-container *ngIf="batteryImage; else defaultIcon">
                <img [src]="batteryImage" alt="Battery" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <span class="image-gridtext">Battery</span>
          </div>
          <div>
            <div class="image-box" (click)="triggerFileInput('right')">
              <ng-container *ngIf="rightImage; else defaultIcon">
                <img [src]="rightImage" alt="Right" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <span class="image-gridtext">Right</span>
          </div>
          <div>
            <div class="image-box" (click)="triggerFileInput('back')">
              <ng-container *ngIf="backImage; else defaultIcon">
                <img [src]="backImage" alt="Back" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <span class="image-gridtext">Back</span>
          </div>
          <div>
            <div class="image-box" (click)="triggerFileInput('left')">
              <ng-container *ngIf="leftImage; else defaultIcon">
                <img [src]="leftImage" alt="Left" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <span class="image-gridtext">Left</span>
          </div>
          <!-- <div>
            <div class="image-box" (click)="triggerFileInput('Fuel-Level')">
              <ng-container *ngIf="fuelLevelImage; else defaultIcon">
                <img [src]="fuelLevelImage" alt="Fuel Level" />
              </ng-container>
              <ng-template #defaultIcon>
                <mat-icon>image</mat-icon>
              </ng-template>
            </div>
            <input type="file" #fuelFileInput (change)="handleFileUpload($event, 'fuel')" hidden />
            <span class="image-gridtext">Fuel Level</span>
          </div> -->
          
          
          <!-- <div class="new-image-grid"> -->
          <div id="added-img1" style="display: none;">
            <!-- <div id="otherimages" class="image-grid"> -->
              <!-- Dynamically added images will appear here -->
            <!-- </div> -->
          </div>
          
          <!-- <div>
            <div class="image-box" (click)="triggerFileInput('add')">
              <ng-container *ngIf="addImage">
                <img [src]="addImage" />
              </ng-container>
                <mat-icon>add</mat-icon>
            </div>
            <span class="image-gridtext">Add</span>
          </div> -->

          <div>
            <div class="image-box" (click)="openBottomSheet('add')" >
              <ng-container *ngIf="addImage; ">
                <img [src]="addImage" alt="Selected Image" />
              </ng-container>
                <mat-icon>add</mat-icon>
            </div>
          </div>
          
        </div>
        <input
          #frontFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('front', $event)"
        />
        <input
          #engineFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('engine', $event)"
        />
        <input
          #batteryFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('battery', $event)"
        />
        <input
          #rightFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('right', $event)"
        />
        <input
          #backFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('back', $event)"
        />
        <input
          #leftFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('left', $event)"
        />
        <input
          #addFileInput
          type="file"
          accept="image/*"
          style="display: none"
          (change)="onImageSelected('add', $event)"
        />
        <div #nextButton class="classnext">
          <button class="create-order-btn"(click)="createJobCard()">NEXT</button>
        </div>
      </div>
      
      
      <!-- --------------------IMAGE SECTION END---------------- -->


    </div>
  </div>
  <!-- Bottom Sheet -->
<div class="overlay1" [class.visible]="isBottomSheetOpen" (click)="closeBottomSheet()"></div>
<div class="bottom-sheet" *ngIf="isBottomSheetOpen">
  <div class="bottom-sheet-content">
    <div  class="close-btm-img1">
      <div class="enter-image-tag">Enter Image Tag </div>
      <button class="close-button-text-img" mat-icon-button (click)="closeBottomSheet()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-form-field appearance="outline" class="matformfield">
      <mat-label >Image Tag</mat-label>
      <input matInput [(ngModel)]="otherTag" >
    </mat-form-field>
    <input type="file" accept="image/*" (change)="onOtherImageSelected($event)" [disabled]="!otherTag" style="padding: 0px 20px !important;"/>
    <div class="save-new-have">
      <button (click)="saveTag()" [disabled]="!otherTag">Save Tag</button>
    </div>
  </div>
</div>
</div>

<div *ngIf="loading">
  <div #dynamicContainers></div>
</div>


<ng-container #vehicleServiceHistoryContainer></ng-container>

<!-- GST Side Slider -->
<div class="overlay" [class.visible]="isVisible" (click)="closeAll()" ></div>
<div *ngIf="gstDetails" class="gst-side-slider">
  <div class="gst-slider-header">
      <mat-icon class="back-btn" (click)="closeGstSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Create Job Card</div>
          <span class="skip-text" (click)="skipForNow()">Skip for now</span>
      </div>
  </div>

  <div class="gst-slider-content">
      <div class="subtext-and-h3">
          <h3>Do you have GST number?</h3>
          
      </div>
      <div class="sub-text">15-digit GSTIN Number.</div>

      <!-- Radio Buttons -->
      <div class="radio-group">
        <label class="radio-container" [ngClass]="{'selected': hasGst === true}">
            <input type="radio" name="gst" [(ngModel)]="hasGst" [value]="true">
            Yes, I have GST Number
            <span class="custom-radio"></span>
        </label>

        <label class="radio-container" [ngClass]="{'selected': hasGst === false}">
            <input type="radio" name="gst" [(ngModel)]="hasGst" [value]="false">
            I don’t have GST Number
            <span class="custom-radio"></span>
        </label>
      </div>

  </div>

  <div class="slider-footer">
      <button class="continue-btn" (click)="continueNextStep()" [disabled]="hasGst === null">Continue</button>
  </div>
</div>
<!-- ====================== GST SECOND-SLIDER -->
<!-- Second GST Slider (Hidden by Default) -->
<div *ngIf="showGstSecondSlider" class="gst-second-slider">
  <div class="gst-slider-header">
      <mat-icon class="back-btn" (click)="closeSecondSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Create Job Card</div>
          <span class="skip-text" (click)="skipForNow()">Skip for now</span>
      </div>
  </div>

  <div class="gst-2nd-slider-content">
      <h3>Enter GST number</h3>
      <div class="sub-text">Your 15-digit GSTIN</div>

      <!-- GST Input Field -->
      <form [formGroup]="customerGstForm">
        <mat-form-field appearance="outline" class="gst-input-field" style="padding: 0px 20px;">
          <mat-label>Enter GST Number</mat-label>
          <input
            matInput
            formControlName="gstNumber"
            maxlength="15"
            (input)="validateGstInput()"
            required
          >
          <mat-error *ngIf="customerGstForm.get('gstNumber')?.hasError('required')">
            GST Number is required
          </mat-error>
          <!-- <mat-error *ngIf="customerGstForm.get('gstNumber')?.hasError('pattern')">
            GST Number must be 15 characters (A-Z & 0-9)
          </mat-error> -->
        </mat-form-field>
      </form>
      
    
    <!-- </form> -->
    
  </div>

  <div class="slider-footer">
    <button class="continue-btn"
            (click)="openBusinessSlider()"
            [disabled]="customerGstForm.get('gstNumber')?.hasError('required') || customerGstForm.get('gstNumber')?.value.length < 15">
      Continue
    </button>
  </div>
  
</div>

<!-- ================== gst 3nd-section-business-section============== -->
<div *ngIf="showBusinessInfoSlider" class="business-info-slider">
  <div class="business-slider-header">
      <mat-icon class="back-btn" (click)="closeBusinessSlider()">keyboard_backspace</mat-icon>
      <div class="getstarted-header">
          <div class="getstardet-text">Business Info</div>
      </div>
  </div>

  <div class="business-slider-content">
      <h3>Business Information</h3>
<form [formGroup] = "customerGstForm">
      <!-- Business Name Field -->
      <mat-form-field appearance="outline" class="business-input-field">
        <mat-label>Business/Company Name</mat-label>
        <input matInput formControlName="businessName" required>
        <mat-error *ngIf="customerGstForm.get('businessName')?.hasError('required')">
          Business Name is required
        </mat-error>
      </mat-form-field>

      <!-- GST Input Field -->
      <mat-form-field appearance="outline" class="gst-input-field">
          <mat-label>GST Number (Optional)</mat-label>
          <input matInput formControlName="gstNumber" (input)="validateGstInput()" maxlength="15">
      </mat-form-field>

      <!-- Choose State Field -->
      <mat-form-field appearance="outline" class="state-input-field" style=" cursor: pointer;">
        <mat-label>Choose your State</mat-label>
        <input
          matInput
          formControlName="state"
          readonly
          (click)="openStateSlider()"
          required
          style="background-color: white; border: none; padding: 0px; cursor: pointer;"
        >
        <mat-error *ngIf="customerGstForm.get('state')?.hasError('required') || !customerGstForm.get('state')?.value">
          State is required
        </mat-error>
      </mat-form-field>
</form>
  </div>

  <div class="slider-footer-business">
      <!-- <button class="continue-btn-business" (click)="openAddressSlider()" 
              >Continue</button> -->
              <!-- <button class="continue-btn-business"
        (click)="openAddressSlider()"
        [disabled]="
          customerGstForm.get('businessName')?.hasError('required') || 
          customerGstForm.get('businessName')?.value.trim().length < 2 ||
          customerGstForm.get('state')?.hasError('required') || 
          !customerGstForm.get('state')?.value
        ">
  Continue
</button> -->
<button class="continue-btn-business"
        (click)="openAddressSlider()"
        [disabled]="
        customerGstForm.get('businessName')?.hasError('required') || 
        customerGstForm.get('businessName')?.value.trim().length < 2 ||
        customerGstForm.get('state')?.hasError('required') || 
        !customerGstForm.get('state')?.value
      ">
  Continue
</button>

              <!-- [disabled]="!businessName || businessName.trim() === ''" -->
  </div>

</div>

<!-- State Selection Sideslider -->
<div class="state-sideslider-overlay" *ngIf="stateSliderOpen">
  <div class="state-sideslider">
    <div class="state-sideslider-header">
      <mat-icon class="back-btn1" (click)="closeStateSlider()">keyboard_backspace</mat-icon>
      <h3>Select State</h3>
      <mat-icon (click)="closeStateSlider()" style="cursor: pointer;">close</mat-icon>
    </div>

    <!-- Search Bar -->
    <div class="state-SearchBarContainerNew">
      <div class="state-SearchBarButton">
        <div class="state-SearchBarIcon">
          <i class="material-icons-search-state">search</i>
        </div>
        <input
          type="text"
          placeholder="Search for States"
          [(ngModel)]="searchTextStates"
          (input)="filterStates()"
          class="state-SearchBarInput"
        />
        <div class="remove-search-suggestion-state" *ngIf="filteredStates.length" (click)="clearStateSearch()">
          <mat-icon>close</mat-icon>
        </div>
      </div>
    </div>

    <!-- Filtered State List -->
    <div class="state-list">
      <div *ngFor="let state of filteredStates" class="state-item" (click)="selectState(state)">
        {{ state.name }} <!-- Ensure 'name' matches the actual field in API response -->
      </div>
    </div>
  </div>
</div>

<!-- Address Slider -->
<div *ngIf="showAddressSlider" class="address-slider">
  <div class="address-slider-header">
    <mat-icon class="back-btn" (click)="closeAddressSlider()">keyboard_backspace</mat-icon>
    <div class="getstarted-header">
      <div class="getstardet-text">Address</div>
    </div>
  </div>

  <div class="address-slider-content">
    <h3>Enter Address</h3>

    <!-- ✅ Form starts here -->
    <form [formGroup]="addressForm" (ngSubmit)="saveAddressDetails()">
      <!-- Address Line 1 -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="addressLine1">
        <mat-error *ngIf="af.addressLine1.hasError('required')">Address Line 1 is required</mat-error>
      </mat-form-field>

      <!-- Address Line 2 -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="addressLine2">
        <mat-error *ngIf="af.addressLine2.hasError('required')">Address Line 2 is required</mat-error>
      </mat-form-field>

      <!-- Pincode -->
      <!-- <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" maxlength="6" required>
        <mat-error *ngIf="af.pincode.hasError">Pincode is required</mat-error>
        <mat-error *ngIf="af.pincode.hasError('pattern')">Enter a valid 6-digit pincode</mat-error>
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" maxlength="6">
        <mat-error *ngIf="af.pincode.touched && af.pincode.hasError('pattern')">
          Enter a valid 6-digit pincode
        </mat-error>
      </mat-form-field>
      

      <!-- City -->
      <mat-form-field appearance="outline" class="address-input-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="city">
        <mat-error *ngIf="af.city.hasError('required')">City is required</mat-error>
      </mat-form-field>

      <!-- ✅ Submit Button should be inside the form -->
      <div class="slider-footer-Address">
        <button class="continue-btn" type="submit">Continue</button>
      </div>
    </form>
  </div>
</div>

